var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('handle-loggedin-player',{attrs:{"buttonType":"is-primary","isRedirectAfterAdded":true,"isPublicViewingButtonAllowed":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }